import { Typography } from "@mui/material"

// Define a reusable style object for paragraph spacing
const paragraphStyle = { mb: 3 }; // mb = margin-bottom, adjust as needed

function TermsAndConditions() {
    return(
        <div>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
            Terms and Conditions
            <Typography variant="caption" sx={paragraphStyle}>
                May 22, 2025
            </Typography>
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                Following are the terms and conditions for using this website.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                By using this website, you agree to the following terms and conditions. 
                If you do not agree to these terms, please do not use this website.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                1. The content of this website is for your general information and use only. 
                It is subject to change without notice.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                2. This website uses cookies to monitor browsing preferences. If you do not 
                want cookies to be stored on your computer, please disable cookies in your browser settings.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                3. This website may contain links to other websites. These links are provided 
                for your convenience to provide further information. We have no responsibility 
                for the content of the linked websites.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                4. Your use of this website and any dispute arising out of such use of the 
                website is subject to the laws of the United States.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                5. We reserve the right to modify these terms and conditions at any time. 
                Your continued use of this website after any changes will constitute your 
                acceptance of the new terms and conditions.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                6. If you have any questions about these terms and conditions, please contact us.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                7. By using this website, you agree to indemnify and hold harmless the 
                website owner and its affiliates from any claims, losses, or damages arising 
                out of your use of this website.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                8. These terms and conditions are governed by the laws of the United States.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                9. If any provision of these terms and conditions is found to be invalid or 
                unenforceable, the remaining provisions will remain in full force and effect.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                10. These terms and conditions constitute the entire agreement between you 
                and the website owner regarding your use of this website.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                11. If you have any questions about these terms and conditions, please contact us.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                12. By using this website, you agree to the terms and conditions set forth 
                above. If you do not agree to these terms, please do not use this website.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                13. These terms and conditions are subject to change without notice. 
                Please check this page periodically for updates.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                14. Your continued use of this website after any changes will constitute 
                your acceptance of the new terms and conditions.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                15. If you have any questions about these terms and conditions, please contact us.
            </Typography>
            <Typography variant="body1" sx={paragraphStyle}>
                16. By using this website, you agree to the terms and conditions set forth 
                above. If you do not agree to these terms, please do not use this website.
            </Typography>
        </div>
    )
}

export default TermsAndConditions;
